import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import DeleteIcon from '@material-ui/icons/Delete';

import CarrierContainer from '../../containers/logistics/Carrier';
import FMPTextField from '../../components/ui/FMPTextField';
import Contacts from '../../components/form/Contacts';
import FMPQuickbooksVendorSelect from '../../components/pureForm/FMPQuickbooksVendorSelect';
import AuthUserContainer from '../../containers/AuthUser';
import FMPSubmitButton from '../../components/form/FMPSubmitButton';

const styles = (theme) => {
	return {
		sectionHeader: {
			margin: '30px 0px 10px 0px',
			textAlign: 'left',
			textTransform: 'uppercase',
			fontSize: 14,
			color: '#777',
			fontWeight: 900,
			letterSpacing: 2,
		},
		paper: {
			width: '100%',
			overflowX: 'auto',
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 20,
			[theme.breakpoints.up('md')]: {
				padding: '10px 40px 40px 40px',
			},
		},
		addInputButton: {
			borderRadius: '100px',
			marginTop: 20,
			marginBottom: 30,
			textTransform: 'uppercase',
		},
		submitButton: {
			fontSize: 18,
			borderRadius: '100px',
			padding: '20px 30px',
			textTransform: 'uppercase',
		},
		helper: {
			borderLeft: `2px solid ${theme.palette.divider}`,
			padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
			margin: '20px 0px',
			fontSize: 14,
			color: '#666',
		},
	};
};
const formFields = {
	name: '',
	scacCode: '',
	address: '',
	deliveryEmails: [''],
	scheduleEmails: [''],
	billingQuickbooksVendorId: '',
	contacts: [
		{
			name: '',
			title: '',
			officePhoneNumber: '',
			mobilePhoneNumber: '',
			email: '',
			note: '',
		},
	],
};

class SaveCarrier extends Component {
	constructor(props) {
		super(props);
		const carrierId = _.get(this.props, ['match', 'params', 'carrierId']);

		this.state = {
			carrierId: carrierId ? parseInt(carrierId, 10) : undefined,
			isUpdate: carrierId,
		};
		this.state = _.merge(this.state, formFields);
	}

	componentDidMount() {
		//- Only used for updates
		const { carrier, getCarrier } = this.props;
		const { isUpdate, carrierId } = this.state;
		if (!isUpdate) {
			return;
		}

		if (!carrier) {
			getCarrier({ params: { carrierIds: [carrierId] } });
		} else {
			this.updateDefaultValues(this.props);
		}
	}

	updateDefaultValues(props) {
		if (!props.carrier) {
			return;
		}
		this.setState(props.carrier);

		if (_.isNull(props.carrier.billingQuickbooksVendorId)) {
			this.setState({ billingQuickbooksVendorId: '' });
		}
	}

	componentDidUpdate(prevProps) {
		if (_.isUndefined(prevProps.carrier) && this.props.carrier) {
			this.updateDefaultValues(this.props);
		}
	}

	handleSave = () => {
		const params = {};
		[
			'name',
			'address',
			'scacCode',
			'contacts',
			'deliveryEmails',
			'scheduleEmails',
			'notes',
			'billingQuickbooksVendorId',
		].forEach((fieldName) => {
			params[fieldName] = this.state[fieldName];
		});

		if (this.state.isUpdate) {
			params.carrierId = this.state.carrierId;
			this.props.updateCarrier({ params });
		} else {
			this.props.addCarrier({ params });
		}
	};

	onChange = (event, fieldName, index, attr) => {
		if (!_.isNumber(index)) {
			this.setState({ [fieldName]: event.target.value });
		} else {
			const inputs = this.state[fieldName].slice();
			if (attr) {
				inputs[index][attr] = event.target.value;
			} else {
				inputs[index] = event.target.value;
			}
			this.setState({ [fieldName]: inputs });
		}
	};

	handlePureChange = _.debounce((value, path) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), value);
			newState[basePath] = base;
		} else {
			newState[basePath] = value;
		}
		this.setState(newState);
	});

	getInputProps = (path, defaultValue) => {
		return {
			path,
			value: this.getValue(path, defaultValue),
			error: this.getError(path),
			onChange: this.handlePureChange,
			md: 6,
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};

	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	addInput = (arrayName) => {
		const val = _.cloneDeep(formFields[arrayName]);
		this.setState({ [arrayName]: this.state[arrayName].concat(val) });
	};

	removeInput = (arrayName, index) => {
		const inputs = this.state[arrayName].slice();
		inputs.splice(index, 1);
		this.setState({ [arrayName]: inputs });
	};

	render() {
		const { classes, carrier, isExternalLogistics } = this.props;
		const { isUpdate, contacts } = this.state;

		if (isUpdate && !carrier) {
			return <div>Fetching carrier information...</div>;
		}
		const verb = isExternalLogistics ? 'View' : isUpdate ? 'Update' : 'Add';
		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Typography variant="h5" align="left" gutterBottom>
								{verb} Carrier
							</Typography>
						</Grid>
					</Grid>
					<Paper className={classes.paper}>
						<div className={classes.sectionHeader}>Carrier Info</div>

						<FMPTextField name={'name'} label={'Carrier name'} controller={this} />

						<FMPTextField name={'scacCode'} label={'SCAC Code'} controller={this} />

						<FMPTextField name={'address'} label={'Carrier Address'} controller={this} />

						<div className={classes.sectionHeader}>Delivery Emails</div>
						{this.state.deliveryEmails.map((email, i) => {
							return (
								<Grid key={i} container spacing={3}>
									<Grid item xs={11} md={5}>
										<TextField
											value={email}
											onChange={(event) => this.onChange(event, 'deliveryEmails', i)}
											label={`Email ${i + 1}`}
											fullWidth
										/>
									</Grid>
									<Grid item xs={1}>
										{this.state.deliveryEmails.length >= 2 && (
											<IconButton
												color="primary"
												className={classes.button}
												onClick={() => this.removeInput('deliveryEmails', i)}
											>
												<DeleteIcon />
											</IconButton>
										)}
									</Grid>
								</Grid>
							);
						})}

						<Button
							variant="contained"
							className={classes.addInputButton}
							onClick={() => this.addInput('deliveryEmails')}
							disabled={isExternalLogistics}
						>
							ADD ANOTHER DELIVERY EMAIL
						</Button>

						<Contacts contacts={contacts} controller={this} isDisabled={isExternalLogistics} />

						{!isExternalLogistics && (
							<>
								<div className={classes.sectionHeader}>Link to Quickbooks</div>
								<FMPQuickbooksVendorSelect
									{...this.getInputProps(`billingQuickbooksVendorId`, '')}
									label={'Quickbooks vendor for billing'}
								/>
							</>
						)}

						{!isExternalLogistics && this.renderScheduleEmails()}

						<div style={{ textAlign: 'right' }}>
							<FMPSubmitButton
								onClick={this.handleSave}
								buttonText={`${verb} Carrier`}
								isDisabled={isExternalLogistics}
								disabledText={'Update permission is disabled'}
							/>
						</div>
					</Paper>
				</Grid>
			</Grid>
		);
	}

	renderScheduleEmails() {
		const { classes } = this.props;
		const { scheduleEmails } = this.state;

		return (
			<>
				<div className={classes.sectionHeader}>Schedule Emails</div>
				<div className={classes.helper}>
					Add any emails that you want to receive a 30 day out delivery schedule of all station and
					bulk deliveries. This will be delivered twice a day, once at 10am and once at 4am.
				</div>

				<div>
					{scheduleEmails.map((email, i) => {
						return (
							<Grid key={i} container spacing={3} alignItems="flex-end">
								<Grid item xs={11} md={5}>
									<TextField
										value={email}
										onChange={(event) => this.onChange(event, 'scheduleEmails', i)}
										label={`Email ${i + 1}`}
										fullWidth
									/>
								</Grid>
								<Grid item xs={1}>
									<IconButton
										color="primary"
										className={classes.button}
										onClick={() => this.removeInput('scheduleEmails', i)}
									>
										<DeleteIcon />
									</IconButton>
								</Grid>
							</Grid>
						);
					})}

					<Button
						variant="contained"
						className={classes.addInputButton}
						onClick={() => this.addInput('scheduleEmails')}
					>
						ADD SCHEDULE EMAIL
					</Button>
				</div>
			</>
		);
	}
}

SaveCarrier.propTypes = {
	classes: PropTypes.object.isRequired,
	getCarrier: PropTypes.func.isRequired,
	addCarrier: PropTypes.func.isRequired,
	updateCarrier: PropTypes.func.isRequired,
	carrier: PropTypes.object,
	isExternalLogistics: PropTypes.bool.isRequired,
};

export default _.flow([withStyles(styles), CarrierContainer, AuthUserContainer])(SaveCarrier);
